module.exports = __webpack_public_path__ + "img/mn.mne3dad1d.svg";